import { pieceLabel } from './engine';
import type { MoveRecord, Piece, Side } from './types';

export function capturedPieces(moves: MoveRecord[], playerSide: Side = 'red'): { human: Piece[]; ai: Piece[] } {
  const human: Piece[] = [];
  const ai: Piece[] = [];
  for (const move of moves) {
    if (!move.captured) continue;
    (move.piece.side === playerSide ? human : ai).push(move.captured);
  }
  return { human, ai };
}

export function moveCueText(move: MoveRecord): string {
  return `${move.notation}${move.captured ? `・吃${pieceLabel(move.captured)}` : ''}`;
}
